import { ref, onMounted } from 'vue';
import { api } from '../api/client';

export interface CompanyInfo {
  name: string;
  registrationNumber: string;
  vatNumber: string;
  addressLine1: string;
  city: string;
  postalCode: string;
  country: string;
  email: string;
  website: string;
}

const cache = ref<CompanyInfo | null>(null);
let fetching: Promise<CompanyInfo> | null = null;

function fetchCompanyInfo(): Promise<CompanyInfo> {
  if (!fetching) {
    fetching = api
      .get('/settings/company')
      .then((r) => {
        cache.value = r.data;
        return r.data;
      })
      .catch(() => null);
  }
  return fetching;
}

export function useCompanyInfo() {
  onMounted(() => {
    if (!cache.value) fetchCompanyInfo();
  });

  return { company: cache };
}
